import { defineEntity, custom } from './_helpers.js';

export default defineEntity(
    'permission',
    {
        updated: custom({ scope: 'access' }),
    },
    { includeDefaultLifecycle: false },
);
